import type { ReactNode } from 'react';

export default function PageHeader({ eyebrow, title, copy, actions }: { eyebrow?: string; title: string; copy?: string; actions?: ReactNode }) {
  return <header className="page-header">
    <div>{eyebrow && <span className="eyebrow">{eyebrow}</span>}<h1>{title}</h1>{copy && <p>{copy}</p>}</div>
    {actions && <div className="page-actions">{actions}</div>}
  </header>;
}
